import React, { useState } from 'react';
import styles from './PermissionsPage.module.css';
import { createRole } from '../../services/roles.service';

interface NewRoleModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}

const NewRoleModal: React.FC<NewRoleModalProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [roleName, setRoleName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!open) return null;

  const handleSave = async () => {
    if (!roleName.trim()) {
      setError('Role name is required');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await createRole({ name: roleName.trim() });
      setRoleName('');
      onSave();
    } catch (err: any) {
      setError(err.message || 'Failed to create role');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setRoleName('');
    setError(null);
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className={styles.modalTitle}>New Role</h2>
        <input
          className={styles.modalInput}
          type="text"
          placeholder="Add New Role"
          value={roleName}
          onChange={(e) => {
            setRoleName(e.target.value);
            setError(null);
          }}
          disabled={loading}
        />
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.modalButtonRow}>
          <button
            className={styles.modalSaveButton}
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Save'}
          </button>
          <button
            className={styles.modalCancelButton}
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewRoleModal;
